import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';

@Component({
    selector: 'app-inventory-usage',
    templateUrl: './inventory-usage.component.html',
    styleUrls: ['./inventory-usage.component.scss'],
    standalone: false
})
export class InventoryUsageComponent implements OnInit {
    partInfos: any;
    startDate: Date;
    endDate: Date;
    includeNonTracked: boolean = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        private appInfo: AppInformationService,
        public auth: AuthService,
        private sessionInfo: SessionInformationService
    ) {}

    async ngOnInit() {
        this.startDate = !!this.sessionInfo.getItem('inventoryUseageStart') ? this.sessionInfo.getItem('inventoryUseageStart') : moment(new Date()).add(-1, 'year').toDate();
        this.endDate = !!this.sessionInfo.getItem('inventoryUseageEnd') ? this.sessionInfo.getItem('inventoryUseageEnd') : moment(new Date()).toDate();
        this.includeNonTracked = !!this.sessionInfo.getItem('inventoryUseageIncludeNonTracked') ? this.sessionInfo.getItem('inventoryUseageIncludeNonTracked') : false;
    }

    resetSearch() {
        this.startDate = moment(new Date()).add(-1, 'year').toDate();
        this.endDate = moment(new Date()).toDate();
    }

    async getData() {
        this.sessionInfo.setItem('inventoryUseageStart', this.startDate, false);
        this.sessionInfo.setItem('inventoryUseageEnd', this.endDate, false);
        this.sessionInfo.setItem('inventoryUseageIncludeNonTracked', this.includeNonTracked, false);
        this.appInfo.pleaseWaitShow();
        this.partInfos = await this.uow.getInventoryUsage(this.startDate, this.endDate,  this.includeNonTracked);
        this.appInfo.pleaseWaitHide();
    }

    async rowPrepare(e) {
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data.id);
    }

    async open(partId: number) {
        this.router.navigate(['/parts/' + (partId ? partId : 'new')]);
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }
}
